import { useRef } from "react";
import type { ChangeEvent, JSX } from "react";
import { VisuallyHidden } from "@aws-amplify/ui-react";

type UploadFilePicker = {
  readonly openFilePicker: () => void;
  readonly filePickerInput: JSX.Element;
};

export function useUploadFilePicker(
  onFilesChosen: (files: File[]) => void,
  acceptAttribute: string,
): UploadFilePicker {
  const filePicker = useRef<HTMLInputElement>(null);

  function handleFilesPicked(event: ChangeEvent<HTMLInputElement>): void {
    const files = Array.from(event.target.files ?? []);
    // Clearing the value lets the same file be picked again after a failed upload.
    event.target.value = "";
    if (files.length > 0) {
      onFilesChosen(files);
    }
  }

  return {
    openFilePicker: () => {
      filePicker.current?.click();
    },
    filePickerInput: (
      <VisuallyHidden>
        <input
          accept={acceptAttribute}
          multiple
          onChange={handleFilesPicked}
          ref={filePicker}
          tabIndex={-1}
          type="file"
        />
      </VisuallyHidden>
    ),
  };
}
